import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { CallState } from '@lcs/shared/api';
import { ExtensionPhonePrivileges } from '../../phones/extension-phone-register/models/extension-phone-privileges';
import { EditPresenceContactPrivileges } from '../../presence-contact-register/models/presence-contact-privileges';
import { EditPresenceContactData } from '../models/edit-presence-contact-data';

@Component({
   changeDetection: ChangeDetectionStrategy.OnPush,
   selector: 'ndt-edit-presence-contact-view',
   styleUrls: ['./edit-presence-contact-view.component.scss'],
   templateUrl: './edit-presence-contact-view.component.html',
   standalone: false,
})
export class EditPresenceContactViewComponent {
   @Input() callState: CallState;

   @Input() presenceContactPrivileges: EditPresenceContactPrivileges;

   @Input() extensionPhonePrivileges: ExtensionPhonePrivileges;

   @Input() selectedAccountId: number | null;

   @Input() presenceContactExtensionId: number;

   @Output() formSubmitted = new EventEmitter<EditPresenceContactData>();

   @Output() formCanceled = new EventEmitter<void>();

   @Input() form: UntypedFormGroup;

   onCloseClick(): void {
      this.formCanceled.emit();
   }

   onCreate(): void {
      if (this.form.valid) {
         this.formSubmitted.emit();
      }
   }

   departmentPrivileges: {
      canAdd: boolean;
      canEdit: boolean;
   } = { canAdd: false, canEdit: false };
}
